
import Vue from "vue";

export default Vue.extend({
    name: "ConditionColor",
    props: {
        color: String,
        sameCondition: Boolean
    },
    data() {
        return {
        };
    }
});
